export const userDetailTypes = {
  GET_PROFILE_DETAIL: 'GET_PROFILE_DETAIL',
  UPDATE_PROFILE_DETAIL: 'UPDATE_PROFILE_DETAIL',
  GET_ACCOUNT_NUMBER: 'GET_ACCOUNT_NUMBER',
  GET_STATE_NAME: 'GET_STATE_NAME'
};
